import { useMemo } from 'react';

import { TODAY } from '@Components/DateRangeButton';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Log Viewer',
    entityNamePlural: 'Log Viewer',
    entityNameModule: 'settings',
    filters: {
      date: {
        $gte: TODAY.start,
        $lte: TODAY.end,
      },
    },
    sort: [{
      id: 'date',
      desc: true,
    }],
  }), [])
}
